import { render, staticRenderFns } from "./First.vue?vue&type=template&id=135922ba&scoped=true&"
import script from "./First.vue?vue&type=script&lang=js&"
export * from "./First.vue?vue&type=script&lang=js&"
import style0 from "./First.vue?vue&type=style&index=0&id=135922ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135922ba",
  null
  
)

export default component.exports